import type { ConcedeAction } from "../types/actions";
import type { StoneFlickingCoreState } from "../types/game-state";
import { getActiveParticipantIds } from "../utils/participant-helpers";

export function applyConcede(
  state: StoneFlickingCoreState,
  action: ConcedeAction,
): StoneFlickingCoreState {
  const updatedEliminated = [
    ...state.eliminatedParticipants,
    action.participantId,
  ];

  const eliminatedEntities = state.entities.map((entity) => {
    if (entity.owner === action.participantId && !entity.eliminated) {
      return { ...entity, eliminated: true };
    }
    return entity;
  });

  const stillActive = getActiveParticipantIds(
    state.participants,
    updatedEliminated,
  );

  const removedFromSubmitted = state.submittedParticipants.filter(
    (id) => id !== action.participantId,
  );
  const newPendingInputs = new Map(state.pendingInputs);
  newPendingInputs.delete(action.participantId);

  if (stillActive.length === 1) {
    return {
      ...state,
      phase: "ENDED",
      eliminatedParticipants: updatedEliminated,
      entities: eliminatedEntities,
      winner: stillActive[0],
      outcomeReason: "CONCEDE",
      isDraw: false,
      pendingInputs: newPendingInputs,
      submittedParticipants: removedFromSubmitted,
    };
  }

  if (stillActive.length === 0) {
    return {
      ...state,
      phase: "ENDED",
      eliminatedParticipants: updatedEliminated,
      entities: eliminatedEntities,
      winner: null,
      outcomeReason: "CONCEDE",
      isDraw: true,
      pendingInputs: newPendingInputs,
      submittedParticipants: removedFromSubmitted,
    };
  }

  return {
    ...state,
    eliminatedParticipants: updatedEliminated,
    entities: eliminatedEntities,
    pendingInputs: newPendingInputs,
    submittedParticipants: removedFromSubmitted,
  };
}
